import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=2f0a640c&scoped=true&"
import script from "./Signup.vue?vue&type=script&lang=js&"
export * from "./Signup.vue?vue&type=script&lang=js&"
import style0 from "./Signup.vue?vue&type=style&index=0&id=2f0a640c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a640c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0a640c')) {
      api.createRecord('2f0a640c', component.options)
    } else {
      api.reload('2f0a640c', component.options)
    }
    module.hot.accept("./Signup.vue?vue&type=template&id=2f0a640c&scoped=true&", function () {
      api.rerender('2f0a640c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Signup.vue"
export default component.exports